var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalWrapper',{staticClass:"l-credits-modal c-credits-modal",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h1',{staticClass:"c-game-header__antimatter"},[_vm._v(" Antimatter Dimensions ")])]},proxy:true}])},[_c('div',{staticClass:"c-credits-modal__body"},[_c('CreditsDisplay',{attrs:{"is-modal":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }